import { useContext, useState } from "react";
import {
    MdOutlineAssignmentReturned,
    MdOutlineAssignmentTurnedIn,
    MdOutlineLocationOn
} from "react-icons/md";
import { SiMicrosoftexcel } from "react-icons/si";
import InfoContext from "../../context/InfoContext";
import { useCustomModal } from "../../hooks/useCustomModal";
import api from "../../services/api";
import { SolicitationsProps } from "../../types/Solicitations";

import Swal from "sweetalert2";

import { ActionModal } from "../ActionModal";
import "./styles.css";

import moment from "moment";
import toast from "react-hot-toast";

type TableProps = {
    list: SolicitationsProps[];
};

interface IAddress {
    zip_code: string;
    address: string;
    number: string;
    district: string;
    description: string;
    city: string;
    state: string;
}

export default function SolicitationsTable({ list }: TableProps) {
    const modal = useCustomModal();
    const [itemId, setItemId] = useState<string>("");
    const { reloadData, setReloadData } = useContext(InfoContext);
    const token = localStorage.getItem("BVAuditor@token");

    async function removeUser(id: string) {
        await api.delete(`solicitations/delete/${id}`);
        // await setIsOpen(false);
        setReloadData(!reloadData);
    }

    async function getAddress(address: IAddress) {
        Swal.fire({
            title: "<strong> <u>Endereço</u></strong>",
            icon: "info",
            html:
                `<b>CEP: </b>${address.zip_code} <br/>` +
                `<b>Endereço: </b>${address.address} <br/>` +
                `<b>Número: </b>${address.number} <br/>` +
                `<b>Bairro: </b>${address.district} <br/>` +
                `<b>Cidade: </b>${address.city} <br/>` +
                `<b>Estado: </b>${address.state} <br/>` +
                `<b>Ponto de referência: </b>${address.description} <br/>`,
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false,
            showDenyButton: true,
            focusConfirm: false,
            denyButtonText: `<i class="fa fa-thumbs-up"></i> Fechar`,
            // confirmButtonText:
            //     '<i class="fa fa-thumbs-up"></i> Fechar',
            confirmButtonAriaLabel: "Thumbs up, great!",
        });
    }

    async function downloadFile(type: string, id: string) {
        try {
            const response = await api.get(
                `solicitations/generate/${type}/${id}`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token?.replaceAll(`"`, "")}`,
                    },
                }
            );
            let url = window.URL.createObjectURL(response.data);
            let a = document.createElement("a");
            a.href = url;
            a.download = `${type === "excell" ? "preAuditoria.xlsx" : "auditoria.pdf"
                }`;
            a.click();
        } catch (e) {
            console.log("erro", e);
        }
    }

    async function messageJustificativa(message: string) {
        Swal.fire({
            icon: "info",
            title: "Justificativa",
            text: message,
        });
    }

    return (
        <>
            <body className="flex items-center justify-center">
                <div className="container hidden sm:block">
                    <table className="flex flex-row flex-no-wrap w-full my-5 overflow-hidden rounded-lg sm:bg-white sm:shadow-lg">
                        <thead className="text-white">
                            {list &&
                                list.map((item) => (
                                    <tr className="flex flex-col mb-2 rounded-l-lg bg-mainGray flex-no wrap sm:table-row sm:rounded-none sm:mb-0">
                                        <th className="p-3 text-left">
                                            Fabrica
                                        </th>
                                        <th className="p-3 text-left">
                                            Data da inspeção
                                        </th>
                                        <th className="p-3 text-left">
                                            Período
                                        </th>
                                        <th className="p-3 text-left">
                                            Artigo
                                        </th>
                                        <th className="p-3 text-left">
                                            Quantidade
                                        </th>
                                        <th className="p-3 text-left">
                                            Responsável
                                        </th>
                                        <th className="p-2 text-left">
                                            Endereço
                                        </th>
                                        <th className="p-3 text-left w-[110px]">
                                            Status
                                        </th>
                                        <th className="p-3 text-left w-[110px]">
                                            Ações
                                        </th>
                                    </tr>
                                ))}
                        </thead>
                        <tbody className="flex-1 sm:flex-none">
                            {list &&
                                list.map((item) => (
                                    <tr className="flex flex-col mb-2 bg-white flex-no wrap sm:table-row sm:mb-0">
                                        <td className="p-3 truncate border border-grey-light">
                                            {item.factory
                                                ? item.factory.fullname
                                                : ""}
                                        </td>
                                        <td className="p-3 border border-grey-light">
                                            {/* {transformDate(item.date_call).slice(
                                                0,
                                                10
                                            )} */}
                                            {moment(item.date_call)
                                                .utc()
                                                .format("DD/MM/YYYY")}
                                        </td>
                                        <td className="p-3 truncate border border-grey-light">
                                            {item.period}
                                        </td>
                                        <td className="p-3 truncate border border-grey-light">
                                            {item.article}
                                        </td>
                                        <td className="p-3 truncate border border-grey-light">
                                            {item.quantity}
                                        </td>
                                        <td className="p-3 truncate border border-grey-light">
                                            {item.responsible}
                                        </td>
                                        <td className="p-2 truncate transition-all duration-500 border border-grey-light hover:bg-gray-100 text-mainGray">
                                            <div className="flex items-center justify-center w-full">
                                                <a
                                                    onClick={() =>
                                                        getAddress(item.address)
                                                    }
                                                    className="cursor-pointer"
                                                >
                                                    <div className="transition-all duration-500 text-mainGray hover:text-mainDarkRed">
                                                        <MdOutlineLocationOn
                                                            size={"1.5em"}
                                                        />
                                                    </div>
                                                </a>
                                            </div>
                                        </td>
                                        <td
                                            className={`border-grey-light border px-2 `}
                                        >
                                            <span
                                                className={`
                                                inline-flex rounded-full
                                                ${item.status == "pendente"
                                                        ? "bg-blue-100"
                                                        : ""
                                                    }
                                                ${item.status == "confirmado"
                                                        ? "bg-blue-100"
                                                        : ""
                                                    }
                                                ${item.status == "cancelado"
                                                        ? "bg-red-100"
                                                        : ""
                                                    }
                                                ${item.status == "reprovado"
                                                        ? item.acceptedOrDenied ===
                                                            undefined
                                                            ? "bg-red-100"
                                                            : item.acceptedOrDenied ===
                                                                true
                                                                ? "bg-green-100"
                                                                : "bg-red-100"
                                                        : ""
                                                    }
                                                ${item.status == "noshow"
                                                        ? "bg-red-100"
                                                        : ""
                                                    }
                                                ${item.status == "aprovado"
                                                        ? "bg-green-100"
                                                        : ""
                                                    }
                                                px-2
                                                text-xs font-semibold
                                                ${item.status == "pendente"
                                                        ? "text-blue-800"
                                                        : ""
                                                    }
                                                ${item.status == "confirmado"
                                                        ? "text-blue-800"
                                                        : ""
                                                    }
                                                ${item.status == "cancelado"
                                                        ? "text-red-800"
                                                        : ""
                                                    }
                                                ${item.status == "reprovado"
                                                        ? item.acceptedOrDenied ===
                                                            undefined
                                                            ? "text-red-800"
                                                            : item.acceptedOrDenied ===
                                                                true
                                                                ? "text-green-800"
                                                                : "text-red-800"
                                                        : ""
                                                    }
                                                ${item.status == "noshow"
                                                        ? "text-red-800"
                                                        : ""
                                                    }
                                                ${item.status == "aprovado"
                                                        ? "text-green-800"
                                                        : ""
                                                    }

                                            `}
                                            >
                                                {item.status == "noshow" ? (
                                                    <>No Show</>
                                                ) : (
                                                    <>
                                                        {item.status.replace(
                                                            /^./,
                                                            (str) =>
                                                                str.toUpperCase()
                                                        )}
                                                    </>
                                                )}
                                                {item.status === "reprovado" &&
                                                    item.acceptedOrDenied !==
                                                    true &&
                                                    item.acceptedOrDenied !==
                                                    false &&
                                                    " e aguardando cliente"}
                                                {item.acceptedOrDenied ===
                                                    true && " e aceito"}
                                                {item.acceptedOrDenied ===
                                                    false && " e negado"}
                                            </span>
                                        </td>
                                        <td className="p-3 transition-all duration-500 border cursor-pointer border-grey-light hover:bg-gray-100 text-mainDarkRed">
                                            <div className="flex items-center justify-start gap-1">
                                                {(item.status === "reprovado" ||
                                                    item.status ===
                                                    "aprovado" ||
                                                    item.status ===
                                                    "noshow") && (
                                                        <div
                                                            className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                            onClick={() =>
                                                                toast.promise(
                                                                    downloadFile(
                                                                        "pdf",
                                                                        item.id
                                                                    ),
                                                                    {
                                                                        loading: 'Carregando...',
                                                                        success: 'Arquivo baixado com sucesso!',
                                                                        error: 'Erro ao baixar arquivo!',
                                                                    }
                                                                )
                                                            }
                                                        >
                                                            <MdOutlineAssignmentReturned size="1.3em" />
                                                        </div>
                                                    )}
                                                {item.status ===
                                                    "confirmado" && (
                                                        <div>
                                                            <a
                                                                href={`/preauditoria/${item.id}`}
                                                            >
                                                                <div
                                                                    className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                                >
                                                                    <MdOutlineAssignmentTurnedIn size="1.3em" />
                                                                </div>
                                                            </a>
                                                        </div>
                                                    )}
                                                {item.status === "noshow" && (
                                                    <a
                                                        href={`/preauditoria/${item.id}`}
                                                    >
                                                        <div
                                                            className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                        >
                                                            <MdOutlineAssignmentTurnedIn size="1.3em" />
                                                        </div>
                                                    </a>
                                                )}
                                                {item.status ===
                                                    "confirmado" && (
                                                        <div>
                                                            <div
                                                                onClick={() =>
                                                                    toast.promise(
                                                                        downloadFile(
                                                                            "excell",
                                                                            item.id
                                                                        ),
                                                                        {
                                                                            loading: 'Carregando...',
                                                                            success: 'Arquivo baixado com sucesso!',
                                                                            error: 'Erro ao baixar arquivo!',
                                                                        }
                                                                    )
                                                                }
                                                                className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                            >
                                                                <SiMicrosoftexcel size="1.3em" />
                                                            </div>
                                                        </div>
                                                    )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <ActionModal
                    type={modal.customModal.icon}
                    title={modal.customModal.title}
                    description={modal.customModal.text}
                    isOpen={modal.customModal.status}
                    setIsOpen={modal.handleCustomModalClose}
                    action={removeUser}
                    itemId={itemId}
                />
            </body>
            <div>
                {list &&
                    list.map((item) => (
                        <div className="flex justify-center h-full mt-4 overflow-hidden bg-white border border-gray-200 rounded-xl sm:hidden ">
                            <div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Fabrica
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Data da inspeção
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Período
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Artigo
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Quantidade
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Responsável
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Endereço
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Status
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 font-semibold text-left text-white border-t bg-mainGray ">
                                    Ações
                                </div>
                            </div>
                            <div className="w-full ">
                                <div className="flex items-center justify-start h-12 px-2 border-t border-grey-light">
                                    {item.factory ? item.factory.fullname : ""}
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 border-t border-grey-light">
                                    {/* {transformDate(item.date_call).slice(
                                                            0,
                                                            10
                                                        )} */}
                                    {moment(item.date_call)
                                        .utc()
                                        .format("DD/MM/YYYY")}
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 border-t border-grey-light">
                                    {item.period}
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 border-t border-grey-light">
                                    {item.article}
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 border-t border-grey-light">
                                    {item.quantity}
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 border-t border-grey-light">
                                    {item.responsible}
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 transition-all duration-500 border-t border-grey-light hover:bg-gray-100 text-mainGray">
                                    <div className="flex items-center justify-start w-full sm:justify-center">
                                        <a
                                            onClick={() =>
                                                getAddress(item.address)
                                            }
                                            className="cursor-pointer"
                                        >
                                            <div className="transition-all duration-500 text-mainGray hover:text-mainDarkRed">
                                                <MdOutlineLocationOn
                                                    size={"1.5em"}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div
                                    className={`border-grey-light border-t h-12 flex justify-start items-center px-2 `}
                                >
                                    <span
                                        className={`
                                                inline-flex rounded-full
                                                ${item.status == "pendente"
                                                ? "bg-blue-100"
                                                : ""
                                            }
                                                ${item.status == "confirmado"
                                                ? "bg-blue-100"
                                                : ""
                                            }
                                                ${item.status == "cancelado"
                                                ? "bg-red-100"
                                                : ""
                                            }
                                                ${item.status == "reprovado"
                                                ? item.acceptedOrDenied ===
                                                    undefined
                                                    ? "bg-red-100"
                                                    : item.acceptedOrDenied ===
                                                        true
                                                        ? "bg-green-100"
                                                        : "bg-red-100"
                                                : ""
                                            }
                                                ${item.status == "noshow"
                                                ? "bg-red-100"
                                                : ""
                                            }
                                                ${item.status == "aprovado"
                                                ? "bg-green-100"
                                                : ""
                                            }
                                                px-2
                                                text-xs font-semibold leading-5
                                                ${item.status == "pendente"
                                                ? "text-blue-800"
                                                : ""
                                            }
                                                ${item.status == "confirmado"
                                                ? "text-blue-800"
                                                : ""
                                            }
                                                ${item.status == "cancelado"
                                                ? "text-red-800"
                                                : ""
                                            }
                                                ${item.status == "reprovado"
                                                ? item.acceptedOrDenied ===
                                                    undefined
                                                    ? "text-red-800"
                                                    : item.acceptedOrDenied ===
                                                        true
                                                        ? "text-green-800"
                                                        : "text-red-800"
                                                : ""
                                            }
                                                ${item.status == "noshow"
                                                ? "text-red-800"
                                                : ""
                                            }
                                                ${item.status == "aprovado"
                                                ? "text-green-800"
                                                : ""
                                            }

                                            `}
                                    >
                                        {item.status == "noshow" ? (
                                            <>Now Show</>
                                        ) : (
                                            <>
                                                {item.status.replace(
                                                    /^./,
                                                    (str) => str.toUpperCase()
                                                )}
                                            </>
                                        )}
                                        {item.status === "reprovado" &&
                                            item.acceptedOrDenied !== true &&
                                            item.acceptedOrDenied !== false &&
                                            " e aguardando cliente"}
                                        {item.acceptedOrDenied === true &&
                                            " e aceito"}
                                        {item.acceptedOrDenied === false &&
                                            " e negado"}
                                    </span>
                                </div>
                                <div className="flex items-center justify-start h-12 px-2 transition-all duration-500 border-t cursor-pointer border-grey-light hover:bg-gray-100 text-mainDarkRed">
                                    <div className="flex items-center justify-start gap-1">
                                        {(item.status === "reprovado" ||
                                            item.status === "aprovado" ||
                                            item.status === "noshow") && (
                                                <div
                                                    onClick={() =>
                                                        toast.promise(
                                                            downloadFile("pdf", item.id),
                                                            {
                                                                loading: 'Carregando...',
                                                                success: 'Arquivo baixado com sucesso!',
                                                                error: 'Erro ao baixar arquivo!',
                                                            }
                                                        )
                                                    }
                                                    className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                >
                                                    <MdOutlineAssignmentReturned size="1.3em" />
                                                </div>
                                            )}
                                        {item.status === "confirmado" && (
                                            <div>
                                                <a
                                                    href={`/preauditoria/${item.id}`}
                                                >
                                                    <div
                                                        className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                    >
                                                        <MdOutlineAssignmentTurnedIn size="1.3em" />
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                        {item.status === "confirmado" && (
                                            <div>
                                                <div
                                                    onClick={() =>
                                                        toast.promise(
                                                            downloadFile(
                                                                "excell",
                                                                item.id
                                                            ),
                                                            {
                                                                loading: 'Carregando...',
                                                                success: 'Arquivo baixado com sucesso!',
                                                                error: 'Erro ao baixar arquivo!',
                                                            }
                                                        )
                                                    }
                                                    className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                >
                                                    <SiMicrosoftexcel size="1.3em" />
                                                </div>
                                            </div>
                                        )}
                                        {item.status === "noshow" && (
                                            <a
                                                href={`/preauditoria/${item.id}`}
                                            >
                                                <div
                                                    className={`text-mainGray hover:text-mainDarkRed transition-all duration-500 `}
                                                >
                                                    <MdOutlineAssignmentTurnedIn size="1.3em" />
                                                </div>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                <ActionModal
                    type={modal.customModal.icon}
                    title={modal.customModal.title}
                    description={modal.customModal.text}
                    isOpen={modal.customModal.status}
                    setIsOpen={modal.handleCustomModalClose}
                    action={removeUser}
                    itemId={itemId}
                />
            </div>
        </>
    );
}
